<template>
  <v-dialog
    v-model="isOpenModalInformationAbonnement"
    :scrim="false"
    scrollable
    persistent
    :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : ''"
    :width="$vuetify.breakpoint.mobile ? '' :'600'"
  >
    <v-card
      class="pt-3"
      :class="$vuetify.breakpoint.mobile ? 'sheet-mobile px-3' : 'sheet px-6'"
    >
      <div
        class="px-3 px-md-0"
        :class="$vuetify.breakpoint.mobile ? 'over' : ''"
      >
        <div
          v-if="!isAbonneCulturial"
          class="d-flex pt-3 justify-space-between caption my-0"
        >
          <v-chip
            color="accent"
            label
            small
          >
            Abonnement
          </v-chip>
          <v-btn
            class="align-self-center"
            text
            small
            @click="onClose"
          >
            <v-icon color="secondary">
              mdi-close
            </v-icon>
          </v-btn>
        </div>

        <div
          class="d-flex"
        >
          <div class="secondary--text align-self-center titre-h3 mr-auto">
            {{ titre }}
          </div>
          <v-btn
            v-if="isAbonneCulturial"
            class="align-self-center"
            text
            @click="onClose"
          >
            <v-icon color="secondary">
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <div
          class="d-flex align-center flex-column py-6"
        >
          <img
            alt="info-abonnement"
            class="resize-image"
            src="@/assets/info-abonnement/info-abonnement.svg"
          >
        </div>
        <div class="d-flex align-center flex-column intro pb-3">
          <div class="align-self-center">
            {{ texte }}
          </div>
        </div>
        <div class="d-flex align-center flex-column titre-h4 secondary--text pb-3">
          <ContactConseiller
            :code-feature="codeFeature"
            :is-conseiller-pv-affiche="isConseillerPvAffiche"
          />
        </div>
        <div
          v-if="hasDemandeRecente"
          class="d-flex justify-center intro secondary--text py-3"
        >
          <v-icon
            class="px-3"
            color="secondary"
          >
            mdi-check
          </v-icon>
          <div class="align-self-center">
            Un email a bien été envoyé
          </div>
        </div>
        <div
          v-if="!isAbonneCulturial"
          class="my-2 d-flex justify-center"
        >
          <v-btn
            class="intro primary--text"
            text
            @click="onAbonnementClick"
          >
            <span
              class="align-self-center"
            >En savoir plus sur l'abonnement </span>
            <v-icon
              class="pr-2 align-self-center"
              color="primary"
            >
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ContactConseiller from '@/components/contact-conseiller.vue'

export default {
  name: 'InformationAbonnementModal',
  components: {ContactConseiller},

  props: {
    titre: {
      type: String,
      default: null
    },
    texte: {
      type: String,
      default: null
    },
    codeFeature: {
      type: String,
      required: true
    },
    isConseillerPvAffiche: {
      type: Boolean,
      default: true
    },
    isOpenModalInformationAbonnement: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      hasDemandeRecente: 'demandeInfosAbonnement/hasDemandeRecente',
      abonnements: 'adherent/abonnements'
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
  },

  methods: {
    onClose () {
      this.$emit('close')
    },
    onAbonnementClick () {
      this.$router.push({ name: 'main.offre-abonnement' })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.resize-image {
  width: 25%;
}
.sheet-mobile {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(100% - 70px);
  border-radius: 0px !important;
}
.over {
  max-height: 700px;
  overflow: auto;
}
.sheet {
  border-radius: 12px;
}

</style>
